module.exports = __webpack_public_path__ + "img/Shiba-BG.790eb264.jpg";